// @systeme: contrat
// L'écran À venir : la semaine ou le mois, jour par jour, déjà trié par le serveur.
import { z } from 'zod';
import { SchemaElement, SchemaJour } from './elements.js';
export const PorteesAVenir = ['semaine', 'mois'];
export const SchemaPorteeAVenir = z.enum(PorteesAVenir);
export const SchemaVueAVenir = z.object({
    portee: SchemaPorteeAVenir,
    debut: SchemaJour,
    fin: SchemaJour,
    jours: z.array(z.object({
        jour: SchemaJour,
        ferie: z.string().nullable(),
        elements: z.array(SchemaElement),
    })),
});
/** Le jour courant, pour les écrans qui doivent dater quelque chose sans rien calculer. */
export const SchemaJourCourant = z.object({ jour: SchemaJour, jourDemain: SchemaJour });
/** L'onglet Notes : les notes, les plus récentes d'abord, à ranger par catégorie côté écran. */
export const SchemaVueNotes = z.object({ notes: z.array(SchemaElement) });
//# sourceMappingURL=a-venir.js.map